<template>
  <div class="backtohome animated fadeInRight " v-on:click="goBack()">
    <Icon size="30" type="ios-arrow-back" />
    BACK
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    Way: String
  },
  methods: {
    goBack() {
      switch (this.Way) {
        case "about":
          this.$router.replace("/About");
          break;
        case "home":
          this.$router.replace("/Home");
          break;
        case "Radiation":
          this.$router.replace("/Radiation");
          break;
        case "Technology":
          this.$router.replace("/Technology");
          break;
        case "Proton":
          this.$router.replace("/Proton");
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.backtohome {
  border-radius: 30px;
  line-height: 50px;
  font-size: 1.5rem;
  color: #fff;
  margin-top: 30px;
  margin-left: 60px;

  z-index: 2;
  position: absolute;
  width: 150px;
  height: 50px;
  border: 20px;
  background-color: black;
}
</style>
